import { Box, Tooltip } from "@mui/material";
import { ReactElement } from "react";
import { P } from "theme/typography";

export function CaseInsightsRefreshTooltip(props: { children: ReactElement<any, any> }) {
  return (
    <Tooltip
      title={
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <P variant="smBold" sx={{ mb: 1, color: "white" }}>
            Refresh Case Insights
          </P>
          <P variant="xs" sx={{ color: "white" }}>
            Request a re-calculation of all automated data points and case workflow data.
          </P>
        </Box>
      }>
      {props.children}
    </Tooltip>
  );
}
